import { Pagination as MuiPagination } from '@mui/material';
import PropTypes from 'prop-types';

import useResponsive from '@/hooks/useResponsive';

Pagination.propTypes = {
  siblingCount: PropTypes.number,
};

/**
 * `Pagination` do MUI que, no celular, tira os vizinhos da página atual.
 *
 * Abaixo de sm o tema dá 44 px a cada página (alvo de toque). Com um vizinho de cada lado são
 * até 9 itens, 396 px, e a lista não cabe numa tela de 360. Sem vizinhos o pior caso são 7 itens,
 * 308 px, e a primeira e a última página continuam a um toque. O `siblingCount` passado pela tela
 * vence; sem ele, o desktop fica com o padrão do tema.
 */
export default function Pagination({ siblingCount, ...other }) {
  const isMobile = useResponsive('down', 'sm');

  return <MuiPagination siblingCount={siblingCount ?? (isMobile ? 0 : undefined)} {...other} />;
}
